// Auto-login for development (DISABLED)
export const setupAutoLogin = (): boolean => {
  // Auto-login disabled - manual login required
  console.log('Auto-login: Disabled - please login manually');
  return false;
};